/**
 * Set the ad tag to match with the corresponding environment
 * @return {String} string value of the environment
 */
export const getEnv = (location) => {
  const url = new URL(location || window.location);

  // This list will be trimmed down in the near future as our environments begin to compress
  switch (url.hostname) {
    case '0.0.0.0':
    case 'localhost':
    case 'dev.marvel.com':
    case 'local.marvel.com':
    case 'local-ssl.marvel.com':
    case 'terrigen-jewel-dev.marvel.com':
      return 'development';

    case 'qa.marvel.com':
    case 'beta-qa.marvel.com':
    case 'terrigen-jewel-qa.marvel.com':
      return 'qa';

    case 'staging.marvel.com':
    case 'marvelstaging.marvel.com':
      return 'staging';

    case 'www.marvel.com':
    case 'marvel.com':
    default:
      return 'production';
  }
}

/**
 * Get host URL
 *
 * @param {String} env environment to compare against
 * @returns {String}
 */
export const getBaseUrl = (env) => {
  switch (env) {
    case 'development':
      return 'https://dev.marvel.com';

    case 'qa':
      return 'https://qa.marvel.com';

    case 'staging':
      return 'https://staging.marvel.com';

    case 'production':
    default:
      return 'https://www.marvel.com';
  }
};

/**
 * Get the CSG environment based on the Marvel environment
 * @return {String} string value of the CSG environment
 */
export const getCSGLink = (env) => {
  const environment = env || getEnv();

  switch (environment) {
    case "development":
    case "qa":
      return "https://mu-dev.marvel.com";

    case "staging":
      return "https://mu-staging.marvel.com";

    case "production":
    default:
      return "https://mu.marvel.com";
  }
}
